// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".meal-text[data-v-011c1f75]{font-weight:700}.meal-text.need[data-v-011c1f75]{color:#8c8c8c;font-weight:700}.meal-text.unnecessary[data-v-011c1f75]{color:#d94a7d;font-weight:700}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
